// extracted by mini-css-extract-plugin
export default {"starting":"StartPageContent_starting__k+rp1","logo":"StartPageContent_logo__yIkhK"};